"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertURIToHTTPS = void 0;
const urls_1 = require("../constants/urls");
function convertURIToHTTPS(url) {
    if (url.startsWith('ipfs://')) {
        return url.replace('ipfs://', urls_1.ZORA_IPFS_GATEWAY);
    }
    return url;
}
exports.convertURIToHTTPS = convertURIToHTTPS;
